module.exports = __webpack_public_path__ + "static/media/download_app.04715fe3.gif";